import {jwtDecode} from 'jwt-decode';
import {DataStatus} from 'platform/components';
import {Center} from 'platform/foundation';

// eslint-disable-next-line no-restricted-imports -- Intended
import {isNil, path} from 'ramda';

import i18n from '@dms/i18n';
import {buildUrl, microsoftOAuthFinish} from '@dms/routes';
import {CommonSkeleton} from '@dms/shared';

import {useBoolean, useOnMount, useQueryState} from 'shared/web';

export function MicrosoftOAuthRedirect() {
  const [state] = useQueryState('state');
  const [hasError, triggerError] = useBoolean(false);

  useOnMount(() => {
    if (isNil(state)) {
      triggerError();
      return;
    }

    try {
      const wsp = state ? path<string>(['wsp'], jwtDecode(state)) : undefined;

      if (isNil(wsp)) {
        triggerError();
        return;
      }

      const url = buildUrl(microsoftOAuthFinish, wsp, true);
      window.location.href = url;
    } catch {
      triggerError();
    }
  });

  return (
    <Center>
      <DataStatus
        isError={hasError}
        errorMessage={i18n.t('page.login.notifications.workspaceNotFound')}
      >
        <CommonSkeleton />
      </DataStatus>
    </Center>
  );
}
